export const systems = [
  {
    id: 1,
    title: "Protocolo (SEMGI)",
    description: "Sistema de gerenciamento de protocolos e documentos",
    url: "https://gestaodacidade.com.br/semgi/login"
  },
  {
    id: 2,
    title: "Processo Administrativo",
    description: "Gestão de processos administrativos e fluxos de trabalho",
    url: "/processo-administrativo"
  },
  {
    id: 3,
    title: "Patrimônio",
    description: "Controle e gestão de bens e patrimônios",
    url: "/patrimonio"
  },
  {
    id: 4,
    title: "Secretarias",
    description: "Portal de acesso às secretarias municipais",
    url: "/secretarias"
  },
  {
    id: 5,
    title: "Legislação",
    description: "Base de consulta da legislação municipal",
    url: "http://gestaodacidade.com.br:3004/legislacao",
  },
  {
    id: 6,
    title: "Servidores",
    description: "Portal do servidor público municipal",
    url: "http://gestaodacidade.com.br:3004/login"
  },
  {
    id: 7,
    title: "Servidores (Interno)",
    description: "Portal de gestão de servidores para uso interno",
    url: "http://192.168.128.251:3004/"
  }
];